import { inject } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import { ApNotificationService } from '../services/index';

export function reportErrorToUserAndServer<T>(
  apNotificationService: ApNotificationService,
  errorResponse: Observable<T> = EMPTY,
) {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      catchError((error: unknown) => {
        apNotificationService.displayStandardErrorAndReport(error);
        return errorResponse;
      }),
    );
  };
}

// same as function above, but normally it's more useful for hot observables
// If retryCount is omitted, retry will try to resubscribe on errors infinite number of times.
export function retryAndReportErrorToUserAndServer<T>(
  apNotificationService: ApNotificationService,
  retryCount?: number,
) {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      tap({
        error: (error: unknown) => {
          apNotificationService.displayStandardErrorAndReport(error);
        },
      }),
      retry(retryCount),
    );
  };
}

export function reportErrorToUserAndServerInstance() {
  const apNotificationService = inject(ApNotificationService);
  return {
    // this was the default call before
    withoutRetry$: <T>(errorResponse?: Observable<T>) => reportErrorToUserAndServer<T>(apNotificationService, errorResponse),
    // similar to withoutRetry$, but more useful for hot observables that don't complete, and we want to allow this subscriber
    // to keep receiving events
    // If retryCount is omitted, retry will try to resubscribe on errors infinite number of times.
    withRetry$: <T>(retryCount?: number) => retryAndReportErrorToUserAndServer<T>(apNotificationService, retryCount),
  } as const;
}
